<template>
	<button
		type="button"
		class="w-full !p-2 flex flex-col gap-1 relative"
		:class="
			isSelected
				? 'button-secondary-no-border !bg-secondary'
				: 'button-primary-no-border !border-quaternary'
		"
		:disabled="disabled"
		@click="$emit('select')"
	>
		<div
			v-show="isSelected"
			class="absolute z-[1] top-[-1px] left-[-1px] bottom-[-1px] right-[-1px] border-[0.5px] border-primary"
		/>
		<div class="flex flex-col">
			<slot name="label" />
			<slot name="price" />
		</div>
	</button>
</template>

<script setup lang="ts">
interface Props {
	isSelected: boolean;
	disabled?: boolean;
}

defineProps<Props>();
defineEmits<{
	(e: "select"): void;
}>();
</script>
